import React, { useState } from 'react';
import './CourseSingle.css';

// Import necessary components
import { Comments, Faqs, PageSidebar, PageTitle, ProfileDetails } from '../../../components';
import { team } from '../../../constants';

// Import FontAwesome icon
import { FaArrowRight, FaCheck, FaCircleNotch } from 'react-icons/fa';

import { useLocation } from 'react-router-dom';



const CourseSingle = () => {

  // State to manage the active tab (e.g., overview, details, etc.)
  const [activeTab, setActiveTab] = useState('overview');

  // Function to handle tab switching
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  // Get course data passed from the previous page
  const location = useLocation();
  const course = location.state;

  // Find the instructor details from the imported instructors array
  const instructor = team.find(inst => inst.name === course.details.instructor);

  // Function to handle form submission
  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent the default form submission behavior
    event.target.reset(); // Reset the form fields
  };

  return (
    <>

      {/* Page Title Section */}
      <PageTitle title={course.title} page={'Course Single'} />

      <section className='course-single page-single'>

        <div className="course-info page-info">

          {/* Course Image */}
          <div className="image">
            <img src={course.image} alt={course.title} />
          </div>

          {/* Course Content */}
          <div className="content tab-info">

            {/* Course Info Tabs - Tab Buttons */}
            <div className="course-info-tabs tab-buttons">
              <button 
                type="button" 
                className={`button ${activeTab === 'overview' ? 'active' : ''}`} 
                onClick={() => handleTabClick('overview')}
              >
                Overview
              </button>
              <button 
                type="button" 
                className={`button ${activeTab === 'curriculum' ? 'active' : ''}`} 
                onClick={() => handleTabClick('curriculum')}
              >
                Curriculum
              </button>
              <button 
                type="button" 
                className={`button ${activeTab === 'instructor' ? 'active' : ''}`} 
                onClick={() => handleTabClick('instructor')}
              >
                Instructor
              </button>
              <button 
                type="button" 
                className={`button ${activeTab === 'reviews' ? 'active' : ''}`} 
                onClick={() => handleTabClick('reviews')}
              >
                Reviews
              </button>
            </div>

            {/* Course Info Tabs - Tab Sections */}
            <div className="tab-sections">

              {/* Overview Tab Section */}
              {activeTab === 'overview' && (

                <div className="overview tab-section active" id="overview">
            
                  {/* Course heading */}
                  <h3 className='main-heading'>{course.title}</h3>

                  {/* Course Content */}
                  {course.overviews.map((overview, index) => (
                    <p key={index}>{overview}</p>
                  ))}

                  {/* Key Features */}
                  <div className='key-features sub-section'>
        
                    <h3 className='sub-heading'>Key Features:</h3>
                    <p>{course.title} provides essential learning elements to enhance Islamic knowledge, understanding, and personal growth.</p>

                    {/* List of Key Features */}
                    <ul>
                      {course.features.map((feature, index) => {
                        return <li key={index}><FaCircleNotch className='icon' />{feature}</li>
                      })}
                    </ul>
        
                  </div>

                  {/* Section for Learning Outcomes */}
                  <div className='learning-outcomes sub-section'>

                    <h3 className='sub-heading'>Learning Objectives:</h3>
                    <p>Participants of {course.title} will gain Islamic knowledge and practical community skills.</p>

                    {/* List of Learning Outcomes */}
                    <ul>
                      {course.objectives.map((outcome, index) => {
                        return <li key={index}><FaArrowRight className='icon' />{outcome}</li>
                      })}
                    </ul>

                  </div>

                  {/* Prerequisites */}
                  <div className='prerequisites sub-section'>

                    <h3 className='sub-heading'>Prerequisites:</h3>
                    <p>Before enrolling in {course.title}, participants should have basic Islamic knowledge and a willingness to learn.</p>

                    {/* List of Prerequisites */}
                    <ul>
                      {course.prerequisites.map((item, index) => {
                        return <li key={index}><FaCheck className='icon' />{item}</li>
                      })}
                    </ul>

                  </div>

                </div>
              )}

              {/* Curriculum Tab Section */}
              {activeTab === 'curriculum' && (
                <div className="tab-section" id="curriculum">
                  {/* Faq Accordion container */}
                  <Faqs faqs={course.curriculum} />
                </div>
              )}

              {/* Instructor Tab Section */}
              {activeTab === 'instructor' && (
                <div className="tab-section">
                  {/* Instructor Details container */}
                  <ProfileDetails type="team" profile={instructor} />
                </div>
              )}

              {/* Reviews Tab Section */}
              {activeTab === 'reviews' && (
                <div className="reviews tab-section" id="reviews">

                  {/* Reviews */}
                  <Comments comments={course.reviews} />

                  <div className='product-review'>
                    {/* Leave a Comment Form */}
                    <form className='form' onSubmit={handleSubmit}>

                      <h2>leave a comment</h2> {/* Comment Form Title */}

                      <div className='input-box'>
                        <input type="text" name="name" className='box' id="name" placeholder="name" required /> {/* Name Input Field */}
                        <input type="email" name="email" className='box' id="email" placeholder="email" required /> {/* Email Input Field */}
                      </div>
                      
                      <textarea cols="30" rows="10" name="comment" className='box' id="comment" placeholder="comment"></textarea> {/* Comment Textarea */}
                      
                      <button type="submit" name="submit" id="submit" className='btn'>submit</button> {/* Submit Button */}

                    </form>

                  </div>

                </div>
              )}

            </div>
          </div>
        </div>

        {/* Sidebar Section */}
        <PageSidebar
          heading={'Course'}
          details={course.details}
          button={{ link: 'contact-us', title: 'Enroll Now' }}
        />

      </section>

     </> 
  );
};

export default CourseSingle;